import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: (theme) => ({
    '.MuiPickerDay-root.Mui-selected': {
      color: `${colors.common.white} !important`,
    },

    '*': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${theme.palette.gray[300]} transparent`,
      ...theme.applyStyles('dark', {
        scrollbarColor: `${theme.palette.black[700]} transparent`,
      }),

      '&::-webkit-scrollbar': {
        width: 6,
        height: 6,
      },

      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.gray[300],
        borderRadius: 8,
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.black[700],
        }),
      },

      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.gray[400],
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.black[600],
        }),
      },
    },
  }),
};
